import React, { ReactElement, Component, useContext, useEffect, useMemo } from "react";
import './pod-restart-alarm.less';
import { injectIntl } from 'react-intl';
import { PodRestartAlarmContext, podRestartAlarm_type_item, podEvent_type_item } from "../../contexts/pod-restart-alarm";
import { ItemsContext, item } from "../../contexts/items";
import { CardSelectableContext } from "../../contexts/card-selectable";
import { SearchTitleContext } from "../../contexts/search-title";
import { http_get, destroy_worker, http_request, response_type } from "../../worker/http-func";
import { IsInTabsContext } from "../../contexts/is-in-tabs";
import TableList from "../../components/table-list/table-list";
import { TableDescContext } from "../../contexts/table-desc";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
import { workspaces_type_item, WorkspaceContext } from "../../contexts/workspaces";
import { NamespaceContext, namespaces_type_item } from "../../contexts/namespaces";
import { UserInfoContext, IUserInfoType } from "../../contexts/user-info";
import { clusters_type_item, ClusterContext } from "../../contexts/clusters";
import { DatacenternameContext } from "../../contexts/datacenter-name";

// 数组扁平化
export const flatten = (arr: any) => {
    let res: any = [];
    arr.map((item: any) => {
        if (Array.isArray(item)) {
            return res = res.concat(flatten(item));
        } else {
            return res.push(item);
        }
    });
    return res;
}

export const PodRestartAlarm: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [PodRestartAlarm, set_PodRestartAlarm]: [podRestartAlarm_type_item[] | undefined, React.Dispatch<React.SetStateAction<podRestartAlarm_type_item[] | undefined>>] = useContext(PodRestartAlarmContext),
        [clusters, set_clusters]: [clusters_type_item[], React.Dispatch<React.SetStateAction<clusters_type_item[]>>] = useContext(ClusterContext),
        set_workspaces: React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>> = useContext(WorkspaceContext)[1],
        set_namespaces: React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>> = useContext(NamespaceContext)[1],
        user_info: IUserInfoType = useContext(UserInfoContext)[0],
        set_items: React.Dispatch<React.SetStateAction<item[]>> = useContext(ItemsContext)[1],
        set_card_selectable: React.Dispatch<React.SetStateAction<boolean>> = useContext(CardSelectableContext)[1],
        set_search_title: React.Dispatch<React.SetStateAction<string>> = useContext(SearchTitleContext)[1],
        set_is_in_tabs: React.Dispatch<React.SetStateAction<boolean>> = useContext(IsInTabsContext)[1],
        set_table_desc: React.Dispatch<React.SetStateAction<string[]>> = useContext(TableDescContext)[1],
        cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
        set_cluster_selected: React.Dispatch<React.SetStateAction<item | undefined>> = useContext(ClusterSelectedContext)[1],
        workspace_selected: item | undefined = useContext(WorkSpaceSelectedContext)[0],
        namespace_selected: item | undefined = useContext(NameSpaceSelectedContext)[0],
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0];

    useEffect(() => () => { destroy_worker() }, []);
    const { formatMessage } = useMemo(() => props.intl, [props]);

    useEffect((): void => {
        user_info.role !== '' && datacenter_name && http_get('pod_restart_aralm', ['clusters', set_clusters], user_info.role, user_info.subscription_id, datacenter_name, '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [set_clusters, user_info.role, user_info.subscription_id, datacenter_name]);

    useEffect((): void => {
        if (clusters?.length) {
            const data: string = sessionStorage.getItem('cluster') || '',
                selected = clusters.find((cluster: clusters_type_item) => cluster.metadata && cluster.metadata.name === data);
            if (selected) set_cluster_selected(selected.metadata);
            else {
                const { metadata }: clusters_type_item = clusters[0];
                set_cluster_selected(metadata);
                sessionStorage.setItem('cluster', metadata?.name);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clusters, set_cluster_selected]);

    useEffect((): void => {
        (async () => {
            if (cluster_selected?.name && datacenter_name) {
                const { name }: item = cluster_selected;
                if ((user_info.role === "workspaceOwner" && user_info.wkOwner_has_namespacedeveloper.includes(cluster_selected?.name)) || user_info.role === 'namespaceDeveloper') {
                    const workspacenames: { name: string, id: string }[] = (await http_request('workspacenames', props, undefined, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspacenames`, 0, user_info.role, user_info.subscription_id, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true) as response_type).items as { name: string, id: string }[];
                    workspacenames && set_workspaces(workspacenames.map(({ name, id }) => { return { metadata: { name: id, labels: { name } } } as workspaces_type_item }));
                } else {
                    name && user_info.role !== '' && datacenter_name !== '' && http_request('workspaces', props, set_workspaces, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspaces`, 0, user_info.role, user_info.subscription_id, datacenter_name, cluster_selected.name || '', undefined, undefined, undefined, undefined, true);
                }
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cluster_selected?.name, set_workspaces, user_info.role, user_info.subscription_id, user_info.wkOwner_has_namespacedeveloper]);

    useEffect((): void => {
        (async (): Promise<void> => {
            if (user_info.role !== '' && cluster_selected?.name && workspace_selected?.name && datacenter_name) {
                await http_request('namespaces', props, set_namespaces, `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name}/workspace/${workspace_selected.name}/namespaces`, 0, user_info.role,
                    user_info.subscription_id, datacenter_name, cluster_selected?.name, undefined, undefined, undefined, undefined, true);
            };
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user_info.role, user_info.subscription_id, cluster_selected?.name, workspace_selected?.name, set_namespaces]);

    useEffect((): void => {
        const cluster_selected_name: string | undefined = cluster_selected?.name,
            namespace_selected_name: string | undefined = namespace_selected?.name;
        if (cluster_selected_name && namespace_selected_name && datacenter_name) {
            http_request('podRestartAlarm', props, set_PodRestartAlarm,
                `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected_name}/namespace/${namespace_selected_name}/podevents`,
                0, user_info.role, user_info.subscription_id, datacenter_name, cluster_selected_name);
        } else {
            set_PodRestartAlarm([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [namespace_selected?.name, cluster_selected?.name, user_info.role, user_info.subscription_id]);

    useEffect((): void => {
        const PodRestartAlarm_list = PodRestartAlarm?.filter((item: podRestartAlarm_type_item) => item.spec.type.toLocaleLowerCase() !== "firststart");
        const PodRestartAlarm_new: podEvent_type_item[] | undefined = PodRestartAlarm_list && PodRestartAlarm_list.map((item: podRestartAlarm_type_item) => ({
            name: item.spec.podname,
            container: item.spec.container,
            type: item.spec.type,
            updateTime: item.spec.updateTimeStamp.toString(),
            restartLog: {
                prelog: JSON.stringify(item.spec.prelog),
                afterlog: JSON.stringify(item.spec.afterlog),
            }
        }));
        set_items(PodRestartAlarm_new ? PodRestartAlarm_new : []);
    }, [user_info.role, set_items, PodRestartAlarm])

    useEffect((): void => {
        set_is_in_tabs(false);
    }, [set_is_in_tabs]);

    useEffect((): void => {
        set_table_desc([`${formatMessage({ id: 'pod_restart_alarm' })}`, `${formatMessage({ id: 'pod_restart_alarm_desc' })}`]);
    }, [set_table_desc, formatMessage]);

    useEffect((): void => {
        set_card_selectable(false);
    }, [set_card_selectable]);

    useEffect(() => {
        set_search_title('ingress');
    }, [set_search_title]);

    return (
        <div className="no_pointer px-20 mt-20">
            <TableList />
        </div>
    )
}

export default injectIntl(PodRestartAlarm);